import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InfoBarComponent } from '@libs/common/components';

@Component({
  selector: 'ui-blocked-customer-info',
  imports: [InfoBarComponent],
  templateUrl: './blocked-customer-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockedCustomerInfoComponent {
}
